import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { useTheme } from '../context/ThemeContext';

const RSKCurrency = ({ amount = 0, showLabel = true, size = 'medium' }) => {
  const { palette } = useTheme();

  const styles = getStyles(size);

  return (
    <View style={styles.container}>
      <View style={styles.coinIcon}>
        <Text style={styles.coinText}>R</Text>
      </View>
      <View style={styles.amountContainer}>
        {showLabel && (
          <Text style={styles.label}>RSK</Text>
        )}
        <Text style={styles.amount}>
          {amount.toLocaleString()}
        </Text>
      </View>
    </View>
  );
};

const getStyles = (size) => {
  const isSmall = size === 'small';
  const isLarge = size === 'large';
  
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: isSmall ? 10 : isLarge ? 16 : 12,
      paddingVertical: isSmall ? 6 : isLarge ? 10 : 8,
      borderRadius: isSmall ? 10 : isLarge ? 14 : 12,
      borderWidth: 2,
      borderColor: '#000000',
      backgroundColor: 'white',
      gap: isSmall ? 6 : isLarge ? 10 : 8,
      ...Platform.select({
        web: {
          boxShadow: '2px 3px 0px rgba(0,0,0,0.9)',
        },
        default: {
          shadowColor: '#000000',
          shadowOffset: { width: 2, height: 3 },
          shadowOpacity: 0.9,
          shadowRadius: 0,
          elevation: 4,
        },
      }),
    },
    coinIcon: {
      width: isSmall ? 20 : isLarge ? 32 : 24,
      height: isSmall ? 20 : isLarge ? 32 : 24,
      borderRadius: isSmall ? 10 : isLarge ? 16 : 12,
      borderWidth: 2,
      borderColor: '#000000',
      backgroundColor: '#FF4747',
      alignItems: 'center',
      justifyContent: 'center',
    },
    coinText: {
      color: 'white',
      fontSize: isSmall ? 10 : isLarge ? 16 : 12,
      fontFamily: 'Archivo',
      fontWeight: '900',
      ...Platform.select({
        web: {
          textShadow: '1px 1px 0px rgba(0,0,0,0.5)',
        },
      }),
    },
    amountContainer: {
      alignItems: 'flex-end',
    },
    label: {
      fontSize: isSmall ? 8 : isLarge ? 12 : 10,
      fontFamily: 'Archivo',
      fontWeight: '600',
      color: '#666666',
    },
    amount: {
      fontSize: isSmall ? 14 : isLarge ? 20 : 16,
      fontFamily: 'Archivo',
      fontWeight: '800',
      color: '#000000',
    },
  });
};

export default RSKCurrency;